import './assets/main.css'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "material-icons/iconfont/material-icons.css";
import "./assets/css/material-kit-pro.css";
import "./assets/css/elixir-theme.css"; // Theme colors
import "./assets/css/elixir-colors.css"; // Elixir Fund custom colors
import "./assets/css/elixir-soft-ui.css"; // Soft UI styling
import "./assets/navbar-fixes.css"; // Fix for funky navbar background colors
import "./assets/css/home-navbar-fix.css"; // Additional fix for navbar line on home page
import "./assets/css/fix-navbar-brand.css"; // Fix for the Elixir logo white box
import "./assets/css/fix-navbar-menu.css"; // Fix for navbar menu visibility
import "./assets/css/form-accessibility.css"; // Enhanced form accessibility
import "./assets/css/loading-indicator.css"; // Loading indicators
import "./assets/css/registry-view-enhancements.css"; // Enhance registry view text visibility
import "./assets/css/enhanced-photo-picker.css"; // Consistent photo picker styling
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import connectToEmulators from './firebase/firebase-emulator'
import { useAuthStore } from './stores/auth'

// Create the app instance
const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Connect to Firebase emulators in development mode and
// Initialize the application
const initializeApp = async () => {
  try {
    // Connect to emulators in development mode
    if (import.meta.env.MODE === 'development') {
      connectToEmulators()
    }
    
    // Get the auth store and initialize auth
    const authStore = useAuthStore()
    await authStore.initAuth()
    console.log('Auth initialized successfully')
  } catch (error) {
    console.error('Error during initialization:', error)
    // We'll continue anyway to prevent a blank screen
  } finally {
    // Mount the app regardless of auth initialization success/failure
    app.mount('#app')
  }
}

// Start the initialization
initializeApp()
